import { useEffect, useState } from 'react';

const DEFAULT_DEBOUNCE_MS = 400;

/**
 * Devuelve el valor recién cuando deja de cambiar, para no consultar en cada tecla.
 * @param {*} value Valor a demorar.
 * @param {number} [delay] Milisegundos de espera.
 * @returns {*} Último valor estable.
 */
export const useDebouncedValue = (value, delay = DEFAULT_DEBOUNCE_MS) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debouncedValue;
};
